import { QuillDeltaToHtmlConverter } from "quill-delta-to-html";

export const convertDeltaToHtmlConverter = (deltaToConvert: {
    ops: unknown[];
}) => {
    return new QuillDeltaToHtmlConverter(deltaToConvert.ops ?? []).convert();
};
